import React from 'react';
import { Paper, Table, TableHead, TableBody, TableRow, TableCell, Typography, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import { groupByCategory, describeEntitlement } from './planUtils';

// Feature × plan grid. The read-only cross-check that makes "Growth has
// fewer invoices than Starter" visible at a glance; each plan header links
// into its builder.
const PlanCompareMatrix = ({ features, plans, t, linkToBuilder = true }) => {
  const groups = groupByCategory(features);
  const entFor = (plan, key) => (plan.entitlements || []).find((e) => e.featureKey === key);

  return (
    <Paper variant="outlined" sx={{ overflowX: 'auto' }}>
      <Table size="small" aria-label={t('Compare plans', { defaultValue: 'Compare plans' })}>
        <TableHead>
          <TableRow>
            <TableCell>{t('Feature', { defaultValue: 'Feature' })}</TableCell>
            {plans.map((p) => (
              <TableCell key={p._id} align="center">
                {linkToBuilder ? (
                  <Link to={`/ga/plans/${p._id}`} style={{ color: 'inherit', textDecoration: 'none' }}>
                    <Typography variant="subtitle2">{p.name}</Typography>
                  </Link>
                ) : <Typography variant="subtitle2">{p.name}</Typography>}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {groups.map((group) => (
            <React.Fragment key={group.category}>
              <TableRow>
                <TableCell colSpan={plans.length + 1} sx={{ bgcolor: 'action.hover' }}>
                  <Typography variant="overline" color="text.secondary">{t(group.category, { defaultValue: group.category })}</Typography>
                </TableCell>
              </TableRow>
              {group.items.map((feature) => (
                <TableRow key={feature.key} hover>
                  <TableCell>
                    <Box>
                      <Typography variant="body2">{feature.name}</Typography>
                      {feature.kind === 'metered' && (
                        <Typography variant="caption" color="text.secondary">{t('per month', { defaultValue: 'per month' })}</Typography>
                      )}
                    </Box>
                  </TableCell>
                  {plans.map((p) => {
                    const d = describeEntitlement(feature, entFor(p, feature.key));
                    return (
                      <TableCell key={p._id} align="center" data-testid={`cell-${p.slug}-${feature.key}`}>
                        <Typography
                          variant="body2"
                          fontWeight={d.kind === 'no' ? 400 : 600}
                          sx={{ color: d.kind === 'no' ? 'text.disabled' : d.kind === 'yes' ? 'success.main' : 'text.primary', fontVariantNumeric: 'tabular-nums' }}
                        >
                          {d.text}
                        </Typography>
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))}
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
};

export default PlanCompareMatrix;
